"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconParkingAids = function IconParkingAids(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "IconParkingAids"), _react.default.createElement("path", {
    d: "M42.9193 13.5H47.9193V11.1H26.4193C22.5193 11.1 19.1193 13.5 17.7193 17C16.7193 17.2 15.9193 18.2 15.9193 19.3V31C15.9193 32.1 16.7193 33.1 17.7193 33.3C19.1193 36.8 22.4193 39.2 26.4193 39.2H47.9193V36.9H42.9193C42.7193 36.9 42.6193 36.6 42.8193 36.5L47.8193 35.1V15.3L42.8193 13.9C42.7193 13.8 42.7193 13.5 42.9193 13.5ZM24.2193 36.7C21.5193 35.5 19.6193 33.1 19.4193 30.4C19.3193 29.8 20.3193 29.5 20.7193 30L25.1193 35.7C25.5193 36.3 24.9193 37 24.2193 36.7ZM25.1193 14.5L20.7193 20.2C20.3193 20.7 19.3193 20.5 19.4193 19.8C19.6193 17.1 21.5193 14.7 24.2193 13.5C24.9193 13.2 25.5193 13.9 25.1193 14.5ZM43.4193 16.5C43.7193 16.6 43.9193 16.9 43.8193 17.3C42.9193 19.8 42.4193 22.4 42.4193 25.2C42.4193 28 42.9193 30.7 43.8193 33.1C43.9193 33.4 43.7193 33.8 43.4193 33.9L35.2193 35.6C34.9193 35.6 34.7193 35.5 34.5193 35.3C33.0193 32.3 32.2193 28.9 32.2193 25.2C32.2193 21.5 33.1193 18.1 34.5193 15.1C34.6193 14.9 34.9193 14.7 35.2193 14.8L43.4193 16.5Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M9.01933 13L6.21933 11C1.91933 17.3 0.819332 25.3 3.31933 32.5C4.11933 34.9 5.31933 37.1 6.81933 39.1L9.61933 37C8.31933 35.3 7.31933 33.4 6.61933 31.4C4.41933 25.3 5.31933 18.4 9.01933 13Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M12.5193 30C10.8193 25.2 11.6193 19.8 14.5193 15.6L11.7193 13.6C8.11933 18.7 7.21933 25.3 9.31933 31.1C10.0193 33 11.0193 34.9 12.2193 36.5L14.9193 34.4C13.9193 33.1 13.1193 31.6 12.5193 30Z",
    fill: color
  }));
};

IconParkingAids.defaultProps = {
  color: 'black',
  size: 30
};
IconParkingAids.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconParkingAids;
exports.default = _default;